<template>
  <div
    v-if="is253Other"
    class="w-full"
  >
    <component
      :is="componentByType[type]"
      v-show="!hidden.includes(question_id)"
      :question="question"
      :subject="subject"
      :question_id="question_id"
      :current-tax-form-id="currentTaxFormId"
      :onboarding-packet-id="onboardingPacketId"
      :set-tax-answers="setTaxAnswers"
      :toggle-required="toggleRequired"
      :required="required"
      :conditional_children="children"
      :current-answer-object="getTaxFormAnswerObjectByQuestionId(question)"
      @child-check="checkShowChild"
      @group-check="checkGroup"
    >
      <tax-tool-tip
        v-if="question.tooltip"
        color-scheme="light"
        :content="question.tooltip"
        class="relative"
        style="top: 1.5px"
      >
        <div class="tooltipStyle">
          <div v-html="question.tooltip" />
          <div
            v-if="question?.instructions_link"
            class="mt-1 block text-right font-semibold text-dark-blue underline"
          >
            <a
              :href="question.instructions_link"
              target="_blank"
            >
              Learn More
            </a>
          </div>
        </div>
      </tax-tool-tip>
    </component>
  </div>
</template>

<script>
import { shallowRef, computed } from 'vue';
import { useStore } from 'vuex';

import TaxToolTip from '@/components/TaxToolTip.vue';
import TextArea from './TextArea.vue';
import Radio from './Radio.vue';
import Checkbox from './Checkbox.vue';
import Input from './Input.vue';
import TextInput from './TextInput.vue';
import Select from './Select.vue';
import Date from './Date.vue';
import File from './File.vue';

const textAreaRef = shallowRef(TextArea);
const radioRef = shallowRef(Radio);
const checkboxRef = shallowRef(Checkbox);
const inputRef = shallowRef(Input);
const textInputRef = shallowRef(TextInput);
const selectRef = shallowRef(Select);
const dateRef = shallowRef(Date);
const fileRef = shallowRef(File);

import Compare from 'expr-eval';
const Parser = Compare.Parser;

export default {
  name: 'DynamicTaxQuestionFormGroup',
  components: {
    TaxToolTip,
  },
  props: {
    item: Object,
    toggleRequired: Function,
    hidden: Array,
    currentTaxFormId: Number,
    currentAnswerObject: [Object, Boolean],
  },
  emits: ['hide', 'unhide', 'group-check2'],
  setup() {
    const store = useStore();
    // const latestTaxFormAnswers = computed(() => {
    //   if (store.state.carriers?.carrierData?.latest_tax_form_submission?.tax_answers?.length > 0 &&
    //       Array.isArray(store.state.carriers?.carrierData?.latest_tax_form_submission?.tax_answers)) {
    //         return [ ...store.state.carriers?.carrierData?.latest_tax_form_submission?.tax_answers ];
    //      }
    //   return [];
    // });
    // const latestTaxFormType = computed(() => store.state.taxQuestions?.latest_company_tax_form_submission?.tax_form?.is_type || null);
    const latestTaxFormType = computed(
      () => store.state.taxQuestions?.current_tax_form || null
    );
    const latestTaxFormAnswers = computed(() => {
      if (
        store.state.taxQuestions?.latest_company_tax_form_submissions?.[
          latestTaxFormType?.value
        ]?.tax_answers?.length > 0 &&
        Array.isArray(
          store.state.taxQuestions?.latest_company_tax_form_submissions?.[
            latestTaxFormType?.value
          ]?.tax_answers
        )
      ) {
        return [
          ...(store.state.taxQuestions?.latest_company_tax_form_submissions?.[
            latestTaxFormType?.value
          ]?.tax_answers ?? []),
        ];
      }
      return [];
    });
    const getTaxFormAnswerObjectByQuestionId = (question) => {
      // console.log('latestTaxFormAnswers.value');
      // console.dir(latestTaxFormAnswers?.value);
      // console.dir(latestTaxFormAnswers);
      // console.log('getTaxFormAnswerObjectByQuestionId - question');
      // console.dir(question);
      if (
        !latestTaxFormAnswers?.value ||
        latestTaxFormAnswers?.value?.length < 1
      ) {
        return null;
      }
      if (
        question &&
        question?.id > 0 &&
        latestTaxFormAnswers?.value?.length > 1
      ) {
        let a = latestTaxFormAnswers.value.find(
          (answer) => answer?.tax_question_id === question?.id
        );
        if (a) {
          return a;
        }
      }
      return false;
    };

    return {
      latestTaxFormAnswers,
      getTaxFormAnswerObjectByQuestionId,
    };
  },
  data() {
    return {
      answer: '',
      question: '',
      id: null,
      question_id: null,
      required: null,
      type: null,
      onboardingPacketId: null,
      componentByType: {
        input_string: textInputRef,
        textarea: textAreaRef,
        radio: radioRef,
        checkbox: checkboxRef,
        input_integer: inputRef,
        input_float: inputRef,
        input_date: dateRef,
        select: selectRef,
        file: fileRef,
        file_multiple: fileRef,
      },
      parents: [],
      children: [],
    };
  },
  computed: {
    subject() {
      return this.question?.subject + (this.required ? ' (Required)' : '');
    },
    is253Other() {
      if (this.question_id !== 254) {
        return true;
      }
      let currentTaxAnswers = [
        ...(this.$store.state.taxQuestions?.tax_answers || []),
      ];
      let a = currentTaxAnswers.find(
        (answer) => answer?.tax_question_id === 253
      );
      let opt = null;
      if (a && a?.tax_answer_options_attributes?.length > 0) {
        opt = a?.tax_answer_options_attributes.find(
          (option) => option?.tax_question_option_id === 164
        );
      }
      if (opt) {
        return true;
      }
      return false;
    },
  },
  watch: {
    item() {
      this.setQuestionData();
    },
    is253Other(newVal, oldVal) {
      if (newVal || (!newVal && oldVal)) {
        setTimeout(() => {
          document
            .querySelectorAll('.shown-tax-question-section-wrap > .vcp__body')
            .forEach((el) => {
              const h = el.querySelector('.vcp__body-content')?.offsetHeight;
              console.log('h: ' + h);
              console.log('el.style.height: ' + el.style.height);
              if (h > 0 && h + 'px' !== el.style.height) {
                el.style.height = h + 'px';
              }
            });
        }, 100);
      }
    },
  },
  mounted() {
    this.setQuestionData();
  },
  methods: {
    setQuestionData() {
      let question = this.item;
      this.id = question?.id;
      this.required = question?.is_required;
      this.question = question;
      this.question_id = question?.id;
      this.type = question?.is_type;
      this.onboardingPacketId =
        this.$store.state.onboardingPacket.onboarding_id;
      this.parents = question?.tax_question_conditions?.parents || [];
      this.children = question?.tax_question_conditions?.children || [];
    },
    async setTaxAnswers(body) {
      let currentAnswers = this.$store.state.taxQuestions.tax_answers;
      let updatedAnswers = [body];
      if (currentAnswers) {
        let filteredAnswers = currentAnswers.filter(
          (el) => el?.tax_question_id !== this.question_id
        );
        if (body) {
          updatedAnswers = [...updatedAnswers, ...filteredAnswers];
        } else {
          updatedAnswers = [...filteredAnswers];
        }
      }
      await this.$store.commit('taxQuestions/setTaxAnswers', updatedAnswers);
    },
    checkShowChild(
      question_id,
      answer,
      predicate,
      is_shown_by_default,
      is_required
    ) {
      this.answer = answer;
      console.log('checkShowChild: value == ' + answer);
      const parser = new Parser();
      let expr = parser.parse(predicate);
      let result = expr.evaluate({ value: answer });
      if (result == true && this.hidden.includes(question_id)) {
        this.$emit('unhide', question_id);
      } else if (result == false && !this.hidden.includes(question_id)) {
        this.$emit('hide', question_id, is_shown_by_default, is_required);
      }
    },
    checkGroup(question_id, group_parent_id, answer) {
      this.$emit('group-check2', question_id, group_parent_id, answer);
    },
  },
};
</script>

<style>
.tooltipStyle * {
  font-size: 0.6rem !important;
}
.tooltipStyle a {
  font-weight: 600 !important;
  text-decoration: underline;
}
.tooltipStyle p {
  margin-bottom: 0.5rem;
}
.tooltipStyle img {
  display: none !important;
}
</style>
